import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Box, TextField, Button } from "@mui/material";
import EastIcon from "@mui/icons-material/East";
import MainDashboardLayout from "../../../../Layout/MainDashboardLayout";
import { put, get } from "../../../../utils/api";
import styles from "../../../../styles/gri/general.module.css";
import AddmultipleTables from "./AddTable";
import GRISidebar from "../../../../Layout/GRISidebar";

import ReviewBox from "../../../../Components/Common/ReviewBox";
import { currentYear } from "../../../../utils/generateYearRanges";

const GRI301_3 = ({ hide }) => {
  const navigate = useNavigate();
  const [griReview, setGriReview] = React.useState(() =>
    JSON.parse(localStorage.getItem("griReview"))
  );

  const { id } = useParams();
  const [disabled, setDisabled] = useState(false);
  const [errors, setErrors] = useState({});
  const [addTables, setaddTables] = useState([
    {
      productName: "",
      productPackaging: "",
      productSold: "",
      percentage: "",
    },
  ]);
  const [text, setText] = useState("");

  const inputData = {
    //   defalut: "Product Name",
    colwidth: "20%",
    fields: [
      { title: "Product Name", fieldName: "productName" },
      {
        title:
          "Products and their packaging materials reclaimed within the reporting period",
        type: "number",
        fieldName: "productPackaging",
      },
      {
        title: "Products sold withing the reporting period",
        type: "number",
        fieldName: "productSold",
      },
      {
        title: "Percentage of reclaimed products and their packaging materials",
        type: "number",
        fieldName: "percentage",
      },
    ],
  };
  //   const defaultSegments = [
  //     {
  //       title: "Non-Renewable Materials Used",
  //       field: "nonrenewable",
  //     },
  //     {
  //       title: "Renewable Materials Used",
  //       field: "renewable",
  //     },
  //   ];

  const handleChange = (e) => {
    setText(e.target.value);
  };

  // useEffect(() => {
  //   setaddTables((prev) =>
  //     prev.map((table) => {
  //       const productPackaging = parseFloat(table.productPackaging) || 0;
  //       const productSold = parseFloat(table.productSold) || 0;

  //       return {
  //         ...table,
  //         percentage:
  //           productSold > 0
  //             ? Number((productSold / productPackaging) * 100).toFixed(2)
  //             : 0,
  //       };
  //     })
  //   );
  // }, [addTables]);

  const fetchData = async () => {
    await get(`/gri/get?type=GRI300&Id=${id}`)
      .then((res) => {
        if (
          res?.data?.data?.year
            ? res?.data?.data?.year < currentYear - 1
            : false
        )
          setDisabled(true);
        const response = res.data.data.GRI300.percentageOfReclaimed;
        setaddTables(
          response.length > 0
            ? response.map((item) => ({
                productName: item?.productName,
                productPackaging: item?.productPackaging,
                productSold: item?.productSold,
                percentage: item?.percentage,
              }))
            : [...addTables]
        );
        setText(res.data.data.GRI300.dataDisclosure);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    fetchData();
  }, []);

  const handleAdd = () => {
    setaddTables((prev) => [
      ...prev,
      {
        productName: "",
        productPackaging: "",
        productSold: "",
        percentage: "",
      },
    ]);
  };
  const validateAddTables = (tables) => {
    console.log(tables, "tables");
    let isValid = true;
    const newErrors = [];

    tables.forEach((row, rowIndex) => {
      const rowErrors = {};
      console.log(row, "tables row");
      if (row?.productName === "") {
        rowErrors.productName = "Product Name is required";
        isValid = false;
      }
      if (row.productPackaging === "") {
        rowErrors.productPackaging = "Product Packaging is required";
        isValid = false;
      }
      if (row.productSold === "") {
        rowErrors.productSold = "Product Sold is required";
        isValid = false;
      }

      newErrors[rowIndex] = rowErrors;
    });

    return { isValid, errors: newErrors };
  };

  const handleSubmit = async () => {
    const { isValid, errors: validationErrors } = validateAddTables(addTables);
    setErrors(validationErrors);

    if (!isValid) {
      // alert("Please fill all required fields");
      return;
    }
    try {
      await put(`/gri/update?Id=${id}`, {
        type: "GRI300",
        submitted301_3: true,
        percentageOfReclaimed: [...addTables],
        dataDisclosure: text,
      })
        .then((res) => navigate(`/gri/gri300/302-1/${id}`))
        .catch((err) => console.log(err));
    } catch (error) {
      console.log(error);
      // setsnackOpen({
      //   open: true,
      //   message: error.data.message,
      //   severity: "error",
      // });
    }
  };

  const renderContent = ({ hide }) => (
    <>
      {!hide && (
        <p
          className={styles.section_heading}
          style={{ textDecoration: "none" }}
        >
          301 :{" "}
          <span className={styles.main_heading_underline}>Material Used</span>
        </p>
      )}
      <p
        className={styles.main_heading}
        style={{ marginBottom: hide ? "-1rem" : "0" }}
      >
        301-3 :{" "}
        <span className={styles.main_heading_underline}>
          Reclaimed products and their packaging materials
        </span>
      </p>
      <Box sx={{ marginleft: "1rem" }}>
        <AddmultipleTables
          title="a. Percentage of reclaimed products and their packaging materials for each product category."
          {...{
            addTables,
            setaddTables,
            errors,
            setErrors,
            inputData,
            //   defaultSegments,
            //   DropDownData,
            handleAdd,
            //   setTotal
            disabled: disabled,
            hide: hide,
          }}
        />
      </Box>
      <p className={styles.ques_heading}>
        b. How the data for this disclosure have been collected.
      </p>
      <TextField
        sx={{ width: "98%", ml: 2, mt: hide ? "-2rem" : "0" }}
        value={text}
        placeholder={"Enter Text"}
        type="text"
        multiline
        minRows={1}
        size="small"
        // variant="standard"
        // InputProps={{ disableUnderline: true }}
        fullWidth
        onChange={(e) => handleChange(e)}
        disabled={disabled}
      />
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap: 2,
          mb: 3,
          mt: 3,
        }}
      ></Box>
    </>
  );

  return (
    <>
      {!hide ? (
        <MainDashboardLayout sidebar={<GRISidebar />}>
          {renderContent({ hide })}

          <>
            {!griReview ? (
              <Box sx={{ width: "98.2%", ml: 2 }}>
                <ReviewBox url={"/gri"} handleSubmit={handleSubmit} />
              </Box>
            ) : (
              <Box textAlign="right" sx={{ mt: 3 }}>
                <Button
                  onClick={handleSubmit}
                  variant="contained"
                  sx={{
                    bgcolor: "#1C486B",
                    textTransform: "none",
                    mt: 3,
                    mb: 5,
                  }}
                >
                  Save & Continue <EastIcon sx={{ ml: 2 }} />
                </Button>
              </Box>
            )}
          </>
        </MainDashboardLayout>
      ) : (
        renderContent({ hide })
      )}
    </>
  );
};
export default GRI301_3;
